import { useQueryClient } from "react-query";
import { useSmartMutation } from "./useSmartMutation";
import { setWorkspacePreferences } from "../apis/crm";

export const useSetWorkspacePreferences = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useSmartMutation("set_pref", setWorkspacePreferences, {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("get_user");
      onSuccess?.(data, variables, context);
    },
    onError,
  });
};
